<template>
  <div>
    <a-form :form="form" @submit="submitContract">
      <a-row class="content" :gutter="20">
        <a-col :span="21">
          <a-row :gutter="20">
            <a-col :span="3">
              <a-form-item class="travel-input-outer">
                <label :class="'filled'">Valor </label>

                <a-input
                  class="travel-input"
                  placeholder="Valor"
                  v-currency
                  :disabled="true"
                  v-decorator="[
                    `payment_methods_bank_transfer_total_value`,
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Preencha o valor.',
                        },
                      ],
                    },
                  ]"
                >
                  <a-icon slot="prefix" type="field-svg" />
                </a-input>
              </a-form-item>
            </a-col>

            <a-col :span="6">
              <a-form-item class="travel-input-outer">
                <label :class="'filled'"
                  >Data de recebimento transferência</label
                >
                <a-date-picker
                  class="travel-input"
                  placeholder="Data de recebimento"
                  format="DD/MM/YYYY"
                  :showToday="false"
                  :allowClear="true"
                  v-mask="'##/##/####'"
                  :disabled="!edit"
                  v-decorator="[
                    `payment_methods_bank_transfer_receipt_date`,
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Obrigatório',
                        },
                      ],
                    },
                  ]"
                >
                  <a-icon slot="prefix" type="field-svg" />
                </a-date-picker>
              </a-form-item>
            </a-col>

            <a-col :span="15">
              <a-form-item class="travel-input-outer">
                <label :class="'filled'">Banco</label>
                <a-select
                  class="travel-input select"
                  placeholder="Banco"
                  :disabled="!edit"
                  allowClear
                  v-decorator="[
                    `payment_methods_bank_transfer_bank`,
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Obrigatório',
                        },
                      ],
                    },
                  ]"
                >
                  <a-select-option
                    v-for="(item, index) of banksList"
                    :key="index"
                    :value="item.account"
                  >
                    {{ item.number }} - {{ item.company_name }} ({{
                      item.cnpj
                    }}) | Ag: {{ item.agency }} - Conta:
                    {{ item.account }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>

        <a-col v-if="sale.status != 'Finalizado'" class="a-right" :span="3">
          <a-button
            v-if="edit"
            @click="editRow('cancel')"
            class="ml-10 cancel"
            type="primary"
          >
            <a-icon type="close" />
          </a-button>

          <a-button
            v-if="!edit"
            @click="editRow('edit')"
            class="ml-10 edit"
            type="primary"
          >
            <a-icon type="edit" />
          </a-button>

          <a-popconfirm
            placement="left"
            ok-text="Sim"
            cancel-text="Não"
            @confirm="confirmAuditory()"
          >
            <template slot="title">
              <p>
                Você confirma todos os valores e dados
                <br />inseridos neste recebimento? Após esta ação <br />
                não será mais possível editar.
              </p>
            </template>
            <a-button
              v-if="!edit"
              html-type="submit"
              class="ml-10 update"
              type="primary"
            >
              <a-icon type="check" />
            </a-button>
          </a-popconfirm>

          <a-button
            v-if="edit"
            html-type="submit"
            class="ml-10 save"
            type="primary"
            style="padding: 0px 6px"
          >
            <img
              src="../../../assets/images/dashboard/sales/disket.png"
              alt="save"
            />
          </a-button>
        </a-col>
      </a-row>
    </a-form>
    <!--
        <pre>{{ tempContract }}</pre> -->
  </div>
</template>

<script>
import formatThings from "@/mixins/general/formatThings.js";
export default {
  props: {
    tempContract: Object,
    sale: Object,
    item: Object,
    index: Number,
  },
  mixins: [formatThings],
  data() {
    return {
      edit: false,
      form: this.$form.createForm(this, {
        onValuesChange: this.updateTempContract,
      }),
      banksList: [],
    };
  },
  mounted() {
    let payments = JSON.parse(this.tempContract.payment_methods);

    this.$http
      .get(
        `/company-bank-accounts/list?page=1&per_page=200&status=Ativo&allow_payments=1`
      )
      .then(({ data }) => {
        this.banksList = data.data;

        setTimeout(() => {
          if (payments.includes("bank-transfer")) {
            this.form.setFieldsValue({
              [`payment_methods_bank_transfer_bank`]:
                this.tempContract[`payment_methods_bank_transfer_bank`],
            });
          }
        }, 100);
      });

    if (payments.includes("bank-transfer")) {
      this.form.setFieldsValue({
        [`payment_methods_bank_transfer_total_value`]:
          this.tempContract[`payment_methods_bank_transfer_total_value`],
        [`payment_methods_bank_transfer_receipt_date`]:
          this.tempContract[`payment_methods_bank_transfer_receipt_date`],
      });
    }
  },
  methods: {
    editRow(type) {
      if (type == "edit") {
        this.edit = true;
      }

      if (type == "cancel") {
        this.edit = false;
      }
    },
    confirmAuditory() {
      let values = {};

      values.payment_methods_bank_transfer_audit_status = "Realizado";
      values.payment_methods_bank_transfer_audit_user_id =
        this.$store.state.userData.id;
      values.id = this.tempContract.id;
      values.sale_id = this.sale.id;
      values.module = "sale";
      values.action = "update-contract-bank-transfer-status-in-sale";
      values.modified_by = {
        name: `${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name}`,
        id: this.$store.state.userData.id,
      };

      this.tempContract["payment_methods_bank_transfer_audit_status"] =
        "Realizado";
      this.tempContract["payment_methods_bank_transfer_audit_user_id"] =
        this.$store.state.userData.id;
      values["sale_receive_active_accordeon"] = this.index;

      this.$http
        .post("/contract/update-multi-meta", values)
        .then(({ data }) => {
          this.$message.success(data.message);
          this.$emit("updateTempContract", this.tempContract);
          this.edit = false;
        })
        .catch(({ response }) => {
          this.$message.error(response.data.message);
        });
    },
    submitContract(e) {
      e.preventDefault();

      this.form.validateFields((err, values) => {
        values.id = this.tempContract.id;
        values.sale_id = this.sale.id;
        values.module = "sale";
        values.action = "update-contract-bank-transfer-in-sale";
        values.modified_by = {
          name: `${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name}`,
          id: this.$store.state.userData.id,
        };

        values.sale_receive_active_accordeon = this.index;

        if (!err) {
          this.$http
            .post("/contract/update-multi-meta", values)
            .then(({ data }) => {
              this.$message.success(data.message);
              this.$emit("updateTempContract", this.tempContract);
              this.edit = false;
            })
            .catch(({ response }) => {
              this.$message.error(response.data.message);
            });
        } else {
          this.$message.error("Prrencha todos os campos.");
        }
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.content
  padding: 20px 20px 0
  .edit
    background: #f27935
    border-color: #f27935
    padding: 5px 10px
  .cancel
    background: #59595b
    border-color: #59595b
    padding: 5px 10px
  .update
    background: #2ecc71
    border-color: #2ecc71
    padding: 5px 10px
  .save
    background: #00acec
    border-color: #00acec
    padding: 0 6px
</style>
